module.exports = __webpack_public_path__ + "img/slide03.a3fd6b79.png";